// extracted by mini-css-extract-plugin
export default {"carrosselEstrutura":"CarrosselEstrutura_carrosselEstrutura__bmLae","slidercontato":"CarrosselEstrutura_slidercontato__xYodj"};